import { render, staticRenderFns } from "./UserRolesDisplay.vue?vue&type=template&id=35b9ac99"
import script from "./UserRolesDisplay.vue?vue&type=script&lang=ts"
export * from "./UserRolesDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports